import { useSnapshot } from '../useSnapshot';
import { useStore } from '../FronteggStoreContext';

// TODO: remove useless stateMapper, valtio already does this

const defaultMapper = state => state;
// @deprecated use useSSOState() instead
export function useSSOState(stateMapper = defaultMapper) {
  return stateMapper(useSnapshot(useStore().store.auth.ssoState));
}
export const useSSOActions = () => {
  return useStore().stateActions.auth.ssoActions;
};